const profile = {
  profile: {
    title: "個人檔案",
    personalInfo: "個人資訊",
    name: "姓名",
    email: "電子郵件",
    updateProfile: "更新檔案",
    createSelfTitle: "建立您的檔案",
    createOtherTitle: "建立新檔案",
    createSelfDesc: "請提供您的出生資訊，以生成個人紫微斗數星盤。",
    createOtherDesc: "請輸入您要為其建立星盤的人的詳細資訊。",
    createSelfSuccess: "您的檔案已成功建立！",
    createOtherSuccess: "檔案已成功建立！",
    createError: "建立檔案時發生錯誤。請重試。",
  },
  settings: {
    title: "設定",
    theme: "主題",
    language: "語言",
    notifications: "通知",
    privacy: "隱私",
    account: "帳戶",
    deleteAccount: "刪除帳戶",
    themes: {
      light: "淺色",
      dark: "深色",
      system: "系統預設",
    },
  },
};

export default profile;
